import styled from 'styled-components';

import { Color, FontWeight } from '../../theme';
import { hexToRgba } from '../../utils';

import { LabelContainerData } from './caseStudySection.types';

export const CaseStudyBox = styled.a`
  text-decoration: none;
`;

export const PhotoBackground = styled.div`
  background-color: ${hexToRgba(Color.black, 0.15)};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const Photo = styled.img`
  height: 250px;
  transition: transform 0.7s;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
`;

export const PhotoContainer = styled.div`
  height: 250px;
  width: 100%;
  overflow: hidden;
  position: relative;
  &:hover {
    ${Photo} {
      transform: scale(1.2);
    }
  }
`;

export const LabelContainer = styled.div<LabelContainerData>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: ${(props: LabelContainerData) => props.backgroundColor || Color.white};
  padding: 35px 30px;
  height: calc(100% - 320px);
`;

export const CountryLabel = styled.div`
  color: ${Color.primary};
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 1.09px;
  line-height: 15px;
  text-transform: uppercase;
`;

export const Label = styled.div`
  color: ${Color.darkGrey};
  font-size: 20px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0;
  line-height: 28px;
  margin: 10px 0 35px;
`;

export const ArrowIcon = styled.img``;
